module.exports = __webpack_public_path__ + "static/img/05.dcdb32d7.png";